/*
|--------------------------------------------------------------------------
| Views: Basic
|--------------------------------------------------------------------------
*/

/**
 * Basic View
 * @namespace
 */
__gh__webApp.views.basic = {

	/**
	 * Post bucket laydown callbacks
	 * @param {object} bucket - bucket object
	 */
	"callbacks": function(bucket){
		var viewName	= bucket.view.name,
			commonJS	= __gh__webApp.common,
			social		= __gh__webApp.social;

		//Twitter
		if (commonJS.hasString(viewName.toLowerCase(), "twitter"))
		{
		    social.twitter.loadAllWidgets();
		}
	},


	"getSubView": function(bucket){
		var commonJS				= __gh__webApp.common,
			commonViewJS			= __gh__webApp.views.common,
			validateBucket			= __gh__webApp.data.validate.bucket,
			items 					= (bucket.items.main) ? bucket.items.main : {},
			hasFeaturedEmbed		= validateBucket.hasFeaturedEmbed(bucket),
			viewFolder				= "buckets/basic",
			viewFolder				= (hasFeaturedEmbed) ? viewFolder +"/featuredEmbed" : viewFolder,
			viewName,items,getItems;
	
		//Check first two items for an image and put image in the first slot, if the first doesn't have an image.
		var featuredImagePosition = __gh__webApp.data.itemValidator({"data":items.slice(0,2),"required":1,"validationMethod":"hasImage"});
		if(featuredImagePosition!==false && featuredImagePosition!==0){
			items.move(featuredImagePosition,0);
		}
	
	
		//Basic Headlines
		var totalRequiredImages = (hasFeaturedEmbed) ? 4 : 5,
			hasRequiredImages 	= __gh__webApp.data.itemValidator({"data":items.slice(0,totalRequiredImages),"required":totalRequiredImages,"validationMethod":"hasImage"});
		if (featuredImagePosition===false || hasRequiredImages===false){
			return __gh__webApp.views.basicHeadlines.getSubView(bucket);
		}
	
	
		//Twitter - 3 images and twitter bucket
		var twitter 		= validateBucket.hasTwitter(bucket);
		if (twitter){
			viewName 		= viewFolder+"/twitter";
			itemCount 		= 3;
			itemCount		= (hasFeaturedEmbed) ? itemCount - 1 : itemCount;
			getItems		= commonViewJS.splitItems(items,itemCount,bucket);
	
			//Update bucket
			bucket.view.name 	= viewName;
			bucket.items 		= {
				"main"				:getItems.main,
				"moreHeadlines"		:getItems.moreHeadlines
			};
			return bucket;
	
		}
	
	
		//Multimedia - Gallery in the first 5 items
		var multimediaPosition = __gh__webApp.data.itemValidator({"data":items.slice(0,5),"required":1,"validationMethod":"isGallery"});
		if (multimediaPosition!==false){
			if(multimediaPosition!=1){
				items.move(multimediaPosition,1);
			}
			viewName 		= viewFolder+"/multimedia";
			itemCount 		= (bucket.hasAd) ? 4 : 6;
			itemCount		= (hasFeaturedEmbed) ? itemCount - 1 : itemCount;
			getItems		= commonViewJS.splitItems(items,itemCount,bucket);
	
			//Update bucket
			bucket.view.name	= viewName,
			bucket.items 		= {
				"main"				:getItems.main,
				"moreHeadlines"		:getItems.moreHeadlines
			};
			return bucket;
		}
	
	
		//Basic - 5 images
		viewName 		= viewFolder+"/standard";
		itemCount 		= (bucket.hasAd) ? 5 : 7;
		itemCount		= (hasFeaturedEmbed) ? itemCount - 1 : itemCount;
		getItems		= commonViewJS.splitItems(items,itemCount,bucket);
	
		//Update bucket
		bucket.view.name 	= viewName,
		bucket.items 		= {
				"main"				:getItems.main,
				"moreHeadlines"		:getItems.moreHeadlines
		};
		return bucket;
	
	
	}
};
